import axios from "axios";
import { environment } from "../config/environment";

export const loginUser = async (slug, data) => {
  return await axios.post(`${environment.auth}/login/${slug || ""}`, data);
};


export const registerCustomer = (data) => {
  return axios.post(environment.customer.add, data);
};